import { t } from '@/hooks/web/useI18n';
import { Layout } from '@/utils/routerHelper';

export const adminRoutes: AppRouteRecordRaw[] = [
  {
    path: '/dashboard',
    component: Layout,
    name: 'Dashboard',
    meta: {
      title: t('router.dashboard'),
      icon: 'ant-design:dashboard-filled'
    },
    // redirect: '/ordres',
    children: [
      {
        path: '',
        component: () => import('@/views/Dashboard/Index.vue'),
        name: 'Analysis',
        meta: {
          title: t('router.dashboard'),
          icon: 'ant-design:dashboard-filled',
          noCache: true,
          affix: true
        }
      }
    ]
  },
  {
    path: '/orders',
    component: Layout,
    name: 'Orders',
    meta: {
      title: t('router.orders'),
      icon: 'bitcoin-icons:transactions-outline'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Orders/Index.vue'),
        name: 'OrderList',
        meta: {
          title: t('router.orders'),
          // icon: 'mdi:instant-deposit',
          icon: 'bitcoin-icons:transactions-outline'
        }
      },
      {
        path: ':id',
        component: () => import('@/views/Orders/Detail.vue'),
        name: 'OrderDetail',
        meta: {
          title: t('router.orderDetails'),
          activeMenu: '/orders',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/merchants',
    component: Layout,
    name: 'Merchants',
    meta: {
      title: t('router.merchants'),
      icon: 'mdi:storefront-outline'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Merchants/Index.vue'),
        name: 'MerchantList',
        meta: {
          title: t('router.merchants'),
          icon: 'mdi:storefront-outline'
        }
      },
      {
        path: 'create',
        component: () => import('@/views/Merchants/Create.vue'),
        name: 'CreateMerchant',
        meta: {
          title: t('router.createMerchant'),
          hidden: true,
        }
      },
      {
        path: ':id',
        component: () => import('@/views/Merchants/Detail.vue'),
        name: 'MerchantDetail',
        meta: {
          title: t('router.merchantDetails'),
          activeMenu: '/merchants',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/payments',
    component: Layout,
    name: 'Payments',
    meta: {
      title: t('router.payments'),
      icon: 'icon-park-outline:payment-method',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Payments/Index.vue'),
        name: 'PaymentChannels',
        meta: {
          title: t('router.payments'),
          icon: 'icon-park-outline:payment-method'
        }
      },
      {
        path: ':paymentId',
        component: () => import('@/views/Payments/Detail.vue'),
        name: 'PaymentDetail',
        meta: {
          title: t('router.paymentDetails'),
          activeMenu: '/payments',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/error',
    component: Layout,
    redirect: '/error/404',
    name: 'Error',
    meta: {
      title: t('router.errorPage'),
      icon: 'ci:error',
      hidden: true
    },
    children: [
      {
        path: '404',
        component: () => import('@/views/Error/404.vue'),
        name: '404',
        meta: {
          title: '404'
        }
      },
      {
        path: '403',
        component: () => import('@/views/Error/403.vue'),
        name: '403',
        meta: {
          title: '403'
        }
      },
      {
        path: '500',
        component: () => import('@/views/Error/500.vue'),
        name: '500',
        meta: {
          title: '500'
        }
      }
    ]
  },
  {
    path: '/authorization',
    component: Layout,
    redirect: '/authorization/users',
    name: 'Authorization',
    meta: {
      title: t('router.authorization'),
      icon: 'eos-icons:role-binding',
      permission: 'manage-user'
    },
    children: [
      {
        path: 'users',
        component: () => import('@/views/Authorization/User/Index.vue'),
        name: 'User',
        meta: {
          title: t('router.user'),
          icon: 'eos-icons:role-binding',
          permission: 'manage-user'
        },
        children: [
          {
            path: ':id',
            component: () => import('@/views/Authorization/User/Detail.vue'),
            name: 'UserDetail',
            meta: {
              title: '用户详情',
              hidden: true
            }
          }
        ]
      },
      {
        path: 'role',
        component: () => import('@/views/Authorization/Role/Role.vue'),
        name: 'Role',
        meta: {
          title: t('router.role'),
          hidden: true
        }
      }
    ]
  },
]